// .......Imports...........
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { Formik, Field, Form } from "formik";
import { connect } from "react-redux";
import axios from "axios"

// .......CSS imports.........
import "../../../assets/css/register/register.css";

// .......Constant imports.............
import {
    no_Numbers,
    no_special_characters,
    name_Range,
    mobile_number,
    alphabet_Check,
} from "../../../constants/registration";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage, deviceType } from "../../../utils/registrationUtils";
import { gaEvent, gaLocationAndContentData } from "../../../utils/index";

// .......Action imports..............
import {
    postUserLoginSignupOtp,
    getUserAuthentication,
    postLoginData,
    postUpdateProfile,
    getCountryCodeData,
    clearLoginDataResponse,
    getUserAuthenticationEmail,
    clearUserLoginSignupOtpResponse,
    clearUserAuthenticationEmailResponse
} from "../../../../store/slices/Registration/CommonSlices";

// ........Icons import...............
import logo from "../../../assets/images/register/logo.svg";
import editIcon from "../../../assets/images/register/edit.png";
import indiaFlag from "../../../assets/images/register/india.svg";
import validIcon from "../../../assets/images/register/green_check.svg";

// .........Component imports..........
import CommonModal from "../../../components/utils/commonModal";
import EmailInputLogin from "../RegistrationOtpVerify/emailInputLogin"
import OtpInput from "../RegistrationOtpVerify/otpInput";
import DataLayerEvents from "../../common/DataLayerEvents";
const OtpVerify = (props) => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const { state } = useLocation();
    const mobileInputRef = useRef(null);
    let date = new Date();

    // state variables
    const [formCurrentState, setFormCurrentState] = useState(cookies.get("loginState") ?? null)
    const [formikValues, setFormikValues] = useState({});
    const [reinitialize, setReinitialize] = useState(true)
    const [fieldErrors, setFieldErrors] = useState({});
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [reloadFlag, setReloadFlag] = useState(true)
    // const [redirectToDestination, setRedirectToDestination] = useState(false);
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    // const [remainingSeconds, setRemainingSeconds] = useState(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0));
    const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
    const [isActive, setIsActive] = useState(true);
    const [isConsentChecked, setIsConsentChecked] = useState(true);

//to check correct current url
const subDomainName = window.location.host?.split(".")[0];
const urlCheck = window.location.href;
let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
 window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/login/otp-verify"];
const currentDeferrerUrl = document.referrer
const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
// const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
const urlObj = currentUrl ? new URL(currentUrl) : null;
const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
// const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/login/otp-verify"];
// const isMatch = urls.some(path => currentUrl?.includes(path));
//---------------------------------------  

    // Add event listener to handle page unload
    useEffect(() => {

        const handleBeforeUnload = (event) => {
            // Cancel the event to prevent the page from refreshing immediately
            event.preventDefault();
            navigate('.', { replace: true });
        };

        if (props.reloadFlagOnExit) {
            window.addEventListener('beforeunload', handleBeforeUnload)
        }

        return (() => {
            window.removeEventListener("beforeunload", handleBeforeUnload);

        })
    }, [props.reloadFlagOnExit])

    // Add event listener to handle user inactivity
    useEffect(() => {
        let timeout;
        const resetTimeout = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setIsActive(false), 900000); // 15 minutes
        };
        const handleActivity = () => {
            setIsActive(true);
            resetTimeout();
        };
        if (!state?.mobile) {
            navigate(`/user/login${window.location.search}`)
        }
        if (deviceType == "web") {
            // Set up event listeners for web
            window.addEventListener('click', handleActivity);
            // window.addEventListener('change', handleActivity);
            window.addEventListener('keydown', handleActivity); // Adding key press event
        } else {
            // Set up event listeners
            window.addEventListener('scroll', handleActivity);
            window.addEventListener('click', handleActivity);
            window.addEventListener('touchstart', handleActivity);
            window.addEventListener('touchmove', handleActivity);
            window.addEventListener('keydown', handleActivity);
        }
        // Set up initial timeout
        resetTimeout();

        return () => {
            if (deviceType == "web") {
                // Clean up event listeners
                window.removeEventListener('click', handleActivity);
                // window.removeEventListener('change', handleActivity);
                window.removeEventListener('keydown', handleActivity);
            } else {
                // Clean up event listeners for mobile
                window.removeEventListener('scroll', handleActivity);
                window.removeEventListener('click', handleActivity);
                window.removeEventListener('touchstart', handleActivity);
                window.removeEventListener('touchmove', handleActivity);
                window.removeEventListener('keydown', handleActivity);
            }
            clearTimeout(timeout);
        }
    }, []);

    // Navigate to login page if user is inactive
    useEffect(() => {
        if (!isActive) {
            navigate(`/user/login${window.location.search}`)
        }
    }, [isActive])

    // Initialize form values and handle browser history state
    useEffect(() => {
        const valuesToPopulate = formCurrentState
        setFormikValues(valuesToPopulate?.formValues)
        props.setRemainingSeconds(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0))

        window.history.pushState(null, "", window.location.href);
        const handlePopstate = (event) => {
            window.location.href = `/user/login${window.location.search}`
        };
        window.onpopstate = handlePopstate;
        setTimeout(() => setReinitialize(false), 50);
        return () => {
            window.onpopstate = handlePopstate; // Clean up the event handler
        };
    }, [])

    // Show success card on OTP sent
    useEffect(() => { //for green flags on otp sent
        if (props.usersLoginSignupOtp) {
            if (props.usersLoginSignupOtp?.otp_on == "mobile") {
                gaEvent("otpmobilesendotpsignin", "login_signup", `${gaLocationAndContentData}`, "");
            } else {
                gaEvent("otpemailsendotpsignin", "login_signup", `${gaLocationAndContentData}`, "");
            }
            setShowSuccessCard(true);
            const timeout = setTimeout(() => {
                setShowSuccessCard(false);
                props.dispatch(clearUserLoginSignupOtpResponse())
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [props.usersLoginSignupOtp]);

    // Handle OTP error case
    useEffect(() => {
        if (props.usersLoginSignupOtpError?.block_user_case === "try_again") {
            const totalRemainingSecs = props.usersLoginSignupOtpError?.available_in?.split(" ")?.[0];
            props.setRemainingSeconds(totalRemainingSecs);
            const currentTime = new Date();
            const currentSeconds = currentTime.getSeconds();
            localStorage.setItem("remainingSeconds", currentSeconds);
        }
    }, [props.usersLoginSignupOtpError])

    // Set login state in cookies
    useEffect(() => {
        if (formCurrentState && !props.loginDatas?.cookies && !props.updateProfileData?.cookies) {
            cookies.set("loginState", formCurrentState, {
                path: "/",
                expires: new Date(date.setDate(date.getDate() + 3)),
                sameSite: "Lax",
                domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
            });
        }
    }, [formCurrentState]);

    // Handle different cases of login data
    useEffect(() => {
        if (props.loginDatas?.required_field?.includes("email_otp") && !formikValues?.otp) {
            let params = {};
            params.otp_on = "email"
            params.otp_action = "send";
            params.email = formikValues?.email;
            setFormCurrentState((prev) => ({ ...prev, sendOtpToEmail: params }))
            props.dispatch(postUserLoginSignupOtp(params))
        }
        if (props.loginDatas?.required_field?.includes("email_confirm")) {
            setIsPopupOpen(true)
        }
        if (props.loginDatas?.required_field?.includes("email")) {
            gaEvent("otpmobileverifysignin", "login_signup", `${gaLocationAndContentData}`, "");
            setFormikValues((prev) => ({ ...prev, otp: null }))
            setFormCurrentState((prev) => ({ ...prev, email_field_visibility: true }))
        }
        if (props.loginDatas?.ask_update_profile && props.loginDatas?.user_id) {
            if (formikValues?.email) {
                gaEvent("otpmobileverifysignin", "login_signup", `${gaLocationAndContentData}`, "");
            }
            cookies.set("loginState", { ...cookies?.get("loginState") || {}, "user_id": props.loginDatas?.user_id }, { // Directly setting cookies because it is navigating before cookies updating through formCurrentState
                path: "/",
                expires: new Date(date.setDate(date.getDate() + 3)),
                sameSite: "Lax",
                domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
            });
            navigate(
                `/user/update-profile${window.location.search}`,
                {
                    state: {
                        user_id: props.loginDatas?.user_id
                    }
                })
        }
        if (props.loginDatas?.ask_update_profile && props.loginDatas?.user_uuid) { //update profile check for new user
            cookies.set("loginState", {formValues: cookies?.get("loginState")?.formValues || {}, userUuid: props.loginDatas?.user_uuid, user_type: props.loginDatas?.user_type} , {
                path: "/",
                expires: new Date(date.setDate(date.getDate() + 1)),
                sameSite: "Lax",
                domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
            });
            sessionStorage.setItem("loginState", JSON.stringify({ ...formCurrentState, userUuid: props.loginDatas?.user_uuid, user_type: props.loginDatas?.user_type, email: formikValues?.email, mobile: formikValues?.mobile }));
            navigate(`/user/complete-profile${window.location.search}`)
            cookies.remove("registrationState", {   // see its use
                path: "/",
                domain: destinationDomain,
            });
        }
    }, [props.loginDatas])

    // Check user authentication with email on email value change
    useEffect(() => {
        if (formikValues?.email && !Object?.keys(fieldErrors)?.length > 0) {
            let params = {};
            params.email = formikValues?.email;
            params.check_otp = 1;
            props.dispatch(getUserAuthenticationEmail(params));
        }
    }, [formikValues?.email])

    const handleConsentCheckboxChange = (event) => {
        setIsConsentChecked(event.target.checked);
    };

    // Form validation function
    const validate = (values) => {
        let errors = {};

        //email

        if (!values?.email) {
            errors.email = "Please enter your email.";
        }
        else if (!/^(?!.*\.{2})[a-zA-Z0-9._%+-]+@(?!\.)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(values?.email) || (values?.email?.[0] == '.') ||
            !/^[^@\s]*@?[^@\s]*$/.test(values?.email) // allow only one @ character
        ) {
            errors.email = "Invalid Email. Please update.";
        }

        //mobile
        if (!values?.mobile) {
            errors.mobile = "Please enter your mobile number.";
        }
        else if (mobile_number.test(values.mobile)) {
            errors.mobile = "Mobile number should start with 6,7,8,9.";
        }
        else if (values.mobile?.length != 10) {
            errors.mobile = "Number must have 10 digits.";
        }
        else if (no_special_characters.test(values.mobile)) {
            errors.mobile = "No special character accepted.";
        }
        else if (alphabet_Check.test(values.mobile)) {
            errors.mobile = "Aplhabets are not allowed.";
        }
        setFormCurrentState((prev) => ({ ...prev, errors }))
        return errors;
    };

    // Function to handle OTP resend timer
    const resendOtpTimer = () => {
        props.setRemainingSeconds(30);
        const currentTime = new Date();
        const currentSeconds = currentTime.getSeconds();
        localStorage.setItem("remainingSeconds", currentSeconds);
    };

    // Function for GA events
    const GAEventsData = () => {
        gaEvent("otpchangemobilesignin", "login_signup", `${gaLocationAndContentData}`, "");
    }

    // Function to update touched fields in form state
    const updateTouchedFields = (touched) => {
        // setFormCurrentState((prev) => ({ ...prev, touched }))
    }

    return (

        <div tabIndex="0">
            <Formik
                initialValues={formikValues}
                enableReinitialize={reinitialize}
                validate={validate}
                validateOnChange={true}
            // validateOnBlur={true}
            >
                {({
                    formik,
                    values,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    errors,
                    touched,
                }) => {

                    // Update formik values and form state on values change
                    useEffect(() => {
                        setFormikValues(values);
                        setFormCurrentState((prev) => ({ ...prev, formValues: values }))
                        const errors = validate(values);
                        setFieldErrors(errors);
                    }, [values]);

                    // Handle OTP submission for both mobile and email
                    const handleOtpSubmit = (mobile = formikValues?.mobile, email = formikValues?.email, otp = formikValues?.otp, emailPopUpConfirmation) => { //for submitting otp response in login api
                        const destinationUrl = getAbsoluteDestinationUrl() ?? createCurrentUrl();
                        let params = {};
                        params.current_url = window.location.href;
                        params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
                        params.destination = destinationUrl
                        params.cta_clicked = "login";
                        params.country_code = "+91";
                        params.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
                        if (props.userIps?.ip ){
                            params.ip = props.userIps?.ip;
                        }
                        if (mobile) {
                            params.mobile_number = mobile;
                        }
                        params.certification = props.domain?.id == 2 ? true : false;
                        if (email)
                            params.email = email;
                        if (mobile && otp && !email) {
                            props.dispatch(clearUserAuthenticationEmailResponse());
                            params.otp = parseInt(otp);
                            params.otp_on = "mobile";
                            setFormCurrentState((prev) => ({ ...prev, mobileVerifyParams: params }))
                        }
                        if (email && !otp)  //this param is added for backend purpose to segregate otp of mobile and email differently.
                            params.mobile_otp_verify = true;
                        if (email && otp?.length == 4
                            && props.loginDatas?.required_field?.includes("email_otp")) {
                            params.otp = parseInt(otp);
                            params.otp_on = "email";
                            setFormCurrentState((prev) => ({ ...prev, emailVerifyParams: params }))
                        }
                        if (props.loginDatas?.required_field?.includes("email_confirm") && emailPopUpConfirmation == "yes") {
                            params.email_confirm = true;
                            setFormCurrentState((prev) => ({ ...prev, verificationParams: params }))
                        }
                        props.dispatch(postLoginData(params));
                    }

                    // Render submit button for email
                    const emailSubmitButton = () => {
                        return (
                            <div className="careers_register_fixed_mobile">
                                <button
                                    type="submit"
                                    disabled={props.userAuthenticationEmail && !errors.email ? false : true}
                                    className={props.userAuthenticationEmail && !errors.email ?
                                        "careers_register_valid_button careers_register_button"
                                        : "careers_register_button"}
                                    onClick={() => {
                                        handleOtpSubmit();
                                        setFieldValue("otp", null);
                                        setFormikValues((prev) => ({ ...prev, otp: null }));
                                    }}
                                >
                                    Submit
                                </button>
                                <p className="careers_register_account">
                                    Don't have a Careers360 account? {" "}
                                    <a href={`/user/register${window.location.search?.replace('&page=login', '')?.replace('?page=login', '')}`}>Sign Up</a> to continue
                                </p>
                            </div>
                        )
                    }

                    // Render verify OTP button for Mobile
                    const verifyOtpButton = () => {
                        return (
                            <div className="careers_register_fixed_mobile">
                                <button
                                    type="submit"
                                    disabled={(formikValues?.otp?.length != 4 || props.loginDatasLoading) ? true : false}
                                    className={formikValues?.otp?.length == 4 ?
                                        "careers_register_valid_button careers_register_button"
                                        : "careers_register_button"}
                                    onClick={() => {
                                        handleOtpSubmit();
                                    }}
                                >
                                    Verify OTP
                                </button>
                                <p className="careers_register_account">
                                    Don't have a Careers360 account? {" "}
                                    <a href={`/user/register${window.location.search?.replace('&page=login', '')?.replace('?page=login', '')}`}>Sign Up</a> to continue
                                </p>
                                {
                                    showSuccessCard &&
                                    <div className="success_card">
                                        OTP sucessfully sent to registered mobile number.
                                    </div>
                                }
                            </div>
                        )
                    }

                    // Render verify OTP button for Email
                    const verifyEmailButton = () => {
                        return (
                            <>
                                <div className="careers_register_fixed_mobile">
                                    <button
                                        type="submit"
                                        disabled={(formikValues?.otp?.length != 4 || props.loginDatasLoading)
                                            ? true : false}
                                        className={formikValues?.otp?.length == 4
                                            ? "careers_register_valid_button careers_register_button"
                                            : "careers_register_button"}
                                        onClick={() => {
                                            handleOtpSubmit();
                                        }}
                                    >
                                        Verify OTP
                                    </button>
                                    <p className="careers_register_account">
                                        Don't have a Careers360 account? {" "}
                                        <a href={`/user/register${window.location.search?.replace('&page=login', '')?.replace('?page=login', '')}`}>Sign Up</a> to continue
                                    </p>
                                </div>
                                {
                                    showSuccessCard &&
                                    <div className="success_card">
                                        OTP sucessfully sent to this Email-ID.
                                    </div>
                                }
                            </>
                        )
                    }

                    // Render read-only mobile input field
                    const readOnlyMobileInput = () => {
                        return (
                            <div className="careers_register_mobile_card white_bg">
                                <>
                                    <span className={"register_country_logo register_country_logo_margin"}>
                                        <img src={indiaFlag} alt="indiaFlag" />
                                    </span>
                                    <span className="register_country_code">{"+91"}</span>
                                </>
                                <div className="careers_register_mobile_number">
                                    <>
                                        <input
                                            type="text"
                                            name="mobile"
                                            className="input_type_number"
                                            value={state?.mobile}
                                            readOnly
                                        />
                                        <span className={"floating_label_active"}>Mobile Number</span>
                                    </>
                                </div>
                                <div>
                                    {(
                                        props.loginDatas?.required_field[0] === "email"
                                        ||
                                        cookies.get("loginState")?.email_field_visibility
                                    ) ? (
                                        <img
                                            src={validIcon}
                                            alt="careers_register_checkIcon"
                                            className="careers_register_valid_icon"
                                        />
                                    ) : (
                                        <div
                                            onClick={() => {
                                                props.dispatch(clearUserLoginSignupOtpResponse());
                                                props.dispatch(clearLoginDataResponse());
                                                GAEventsData();
                                                // redirect to input field page on click on edit button
                                                navigate(
                                                    `/user/login${window.location.search}`,
                                                    {
                                                        state: {
                                                            mobile: state?.mobile
                                                        }
                                                    })
                                            }}
                                            className="edit_card"
                                        >
                                            <img src={editIcon} alt="edit_icon" />
                                            <span>Edit</span>
                                        </div>
                                    )}
                                </div>
                            </div >
                        )
                    }
                    return (
                        <>
                            <DataLayerEvents contentType={"Login/Signup"} pageTypes={"login_otp_verify"} verticalName={props.domain?.domain} />

                            <Form>
                                {readOnlyMobileInput()}
                                {["email", "email_otp", "email_confirm"]?.includes(props.loginDatas?.required_field[0])
                                    || cookies.get("loginState")?.email_field_visibility
                                    ?
                                    <>
                                        <EmailInputLogin
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            name={"email"}
                                            otpGetClicked={() => otpGetClicked()}
                                            geolocationData={props.geolocationData}
                                            updateTouchedFields={updateTouchedFields}
                                            mobileInputRef={mobileInputRef}
                                            screen="login"
                                            setFormCurrentState={setFormCurrentState}
                                            formCurrentState={formCurrentState}
                                        />
                                        {(props.loginDatas?.required_field[0] == "email" || !(cookies.get("loginState")?.sendOtpToEmail?.otp_action == "send"))
                                            && !props.loginDatas?.required_field?.includes("email_otp") && emailSubmitButton()}
                                    </>
                                    :
                                    <>
                                        <OtpInput
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleOtpSubmit={(a, b, otp) => handleOtpSubmit(undefined, undefined, otp)}
                                            setFormCurrentState={setFormCurrentState}
                                            resendOtpTimer={resendOtpTimer}
                                            setRemainingSeconds={props.setRemainingSeconds}
                                            remainingSeconds={props.remainingSeconds}
                                            setFormikValues={setFormikValues}
                                        />
                                        {verifyOtpButton()}
                                        {/* done for testing purpose */}
                                    </>
                                }
                                {(props.loginDatas?.required_field?.includes("email_otp") || cookies.get("loginState")?.sendOtpToEmail?.otp_action == "send") &&
                                    <>
                                        <OtpInput
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleOtpSubmit={(a, b, otp) => handleOtpSubmit(undefined, undefined, otp)}
                                            setFormCurrentState={setFormCurrentState}
                                            resendOtpTimer={resendOtpTimer}
                                            setRemainingSeconds={props.setRemainingSeconds}
                                            remainingSeconds={props.remainingSeconds}
                                            setFormikValues={setFormikValues}
                                        />

                                        {verifyEmailButton()}
                                        {/* done for testing purpose */}

                                    </>

                                }
                            </Form>

                            {/* popup opens when user submit the new email */}
                            <CommonModal
                                isOpen={isPopupOpen}
                                showCloseIcon={false}
                                closeOnOverlayClick={false}
                                closeOnEsc={false}
                                closeModal={() => {
                                    setIsPopupOpen(false);
                                }}
                                classNames={{ root: "continue_modal" }}
                            >
                                <div className="careers_register_modal_email">
                                    <div className="careers_register_modal_header">
                                        <img src={logo} alt="logo" />
                                    </div>
                                    {props.loginDatas?.required_field?.includes("email_confirm") &&
                                        <div className="careers_register_modal_body">
                                            <p>Do you want to continue with this email ?</p>
                                            <span className="email_confirmation_popup_span">{values.email}</span>
                                            <div className="careers_register_modal_buttons">
                                                <button onClick={() => { setIsPopupOpen(false); handleOtpSubmit(undefined, undefined, undefined, "yes"); }} 
                                                disabled={isConsentChecked ? false : true}
                                                className={isConsentChecked ? "careers_register_modal_button_active" : "careers_register_modal_button"}>
                                                    Yes
                                                </button>
                                                <button onClick={() => {
                                                    setIsPopupOpen(false);
                                                    props.dispatch(clearLoginDataResponse()) //added for update popup state.
                                                    setTimeout(() => {
                                                        if (mobileInputRef.current) {
                                                            mobileInputRef.current.focus();
                                                        }
                                                    }, 1000);
                                                }}>
                                                    No
                                                </button>
                                                <div className="careers_register_custom_checkbox">
                                                    <Field type="checkbox" id="terms" name="terms"
                                                        checked={isConsentChecked}
                                                        onChange={(e) => {
                                                            handleConsentCheckboxChange(e)
                                                        }}
                                                        required />
                                                    <label htmlFor="terms" className="careers_register_terms careers_register_terms_outer">
                                                        <span className="careers_register_terms_data"> I agree to Careers360’s <a className="careers_register_terms_and_condition" href="https://www.careers360.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy </a>
                                                            and <a className="careers_register_terms_and_condition" href="https://www.careers360.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms &
                                                                Conditions</a> and provide consent to be contacted for promotion via mail, sms, whatsapp, rcs etc.
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </CommonModal>
                        </>
                    );
                }}
            </Formik >
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        usersOtpCheck: state.usersCommonData?.userLoginSignupOtp,
        usersAuthentication: state.usersCommonData?.userAuthentication,
        userAuthenticationErrors: state.usersCommonData?.userAuthenticationError,
        geolocationData: state.usersCommonData?.geoLocation,
        loginDatas: state.usersCommonData?.loginData,
        loginDatasLoading: state.usersCommonData?.loginDataLoading,
        loginDatasError: state.usersCommonData?.loginDataError,
        usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
        usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
        updateProfileData: state.usersCommonData?.updateProfile,
        emailDomainDatas: state.usersCommonData?.emailDomainData,
        countryCodeData: state.usersCommonData?.countryCode,
        userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
        userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
        userIps: state.usersCommonData?.userIp,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OtpVerify);